export default "__VITE_ASSET__32fc4e5c__"